const regex = {
  phone: /^$|^[56789]\d{9}$/,
};

export default regex;



// WEBPACK FOOTER //
// ./src/constants/regex.js